export default {"src":"/_next/static/media/icon-twitter.17e5cdaf.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};